import cookie from 'js-cookie';
import { useCallback } from 'react';
import { httpClient } from '@alfa-bank/site-http-client';
import { ROUPER_PERSONALIZATION_URL } from '@alfa-bank/site-envconfig';

import type { IBanditCallback } from '../models';

import { REWARD_HASH_KEY, SESSION_ID_KEY } from './config';

export const useRouperPersonalizationCallBack = (isAnalitycsEnabled: boolean) => {
    const rewardHash = cookie.get(REWARD_HASH_KEY);
    const sessionId = cookie.get(SESSION_ID_KEY)?.split('.')[0];

    return useCallback(
        ({ tagGroupId }: IBanditCallback) => {
            if (
                !isAnalitycsEnabled ||
                !rewardHash ||
                !sessionId ||
                !ROUPER_PERSONALIZATION_URL() ||
                tagGroupId === undefined
            ) {
                return;
            }

            const url = ROUPER_PERSONALIZATION_URL();

            httpClient
                .post(url, {
                    tagGroupId: tagGroupId,
                    contextHash: rewardHash,
                    sessionId: sessionId,
                })
                .catch(
                    /* istanbul ignore next */ err =>
                        console.error('не получилось послать запрос', err)
                );
        },
        [isAnalitycsEnabled, rewardHash, sessionId]
    );
};
